import Layout from 'components/Layout/Layout';
import MyPage from 'components/MyPage/MyPage';
import OgMetadata from 'components/OgMetadata/OgMetadata';
import { DataLayerPageType } from 'frontend/enums';
import { CategoryItem } from 'frontend/types';
import usePageTracking from 'frontend/utils/hooks/usePageTracking';
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { getCategoriesForMenu } from 'utils/categoryUtil';
interface Props {
  highlightedCategories: CategoryItem[];
  minorityLanguageCategories: CategoryItem[];
}
const MyPagePage = ({
  highlightedCategories,
  minorityLanguageCategories
}: Props) => {
  usePageTracking(DataLayerPageType.MY_PAGE);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
        <title>Min sida - UR Play</title>
        <meta name="description" content="Min sida - UR Play" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
        <OgMetadata title="Min sida - UR Play" description="Min sida" type="article" sharePath={'/min-sida'} data-sentry-element="OgMetadata" data-sentry-source-file="index.tsx" />
      </Head>
      <Layout categories={highlightedCategories} minorityLanguageCategories={minorityLanguageCategories} data-sentry-element="Layout" data-sentry-source-file="index.tsx">
        <MyPage data-sentry-element="MyPage" data-sentry-source-file="index.tsx" />
      </Layout>
    </>;
};
export const getStaticProps: GetStaticProps = async () => {
  const {
    highlightedCategories,
    minorityLanguageCategories
  } = await getCategoriesForMenu();
  return {
    props: {
      highlightedCategories,
      minorityLanguageCategories
    },
    //  Will rebuild this page at most once every hour, or when a request comes in
    revalidate: 3600 // seconds
  };
};
export default MyPagePage;